<p-dialog
  [header]="'PAGINA_RECUPERAR_SENHA.ETAPA_2.TITULO' | translate"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  appendTo="body"
  [baseZIndex]="1100"
  [style]="{ width: '520px', maxWidth: '95vw' }"
  styleClass="rs-conta-dialog"
  (onHide)="onCancelar()"
>
  @if ($loadingEnvio()) {
    <div class="rs-loading">
      <p-progressSpinner></p-progressSpinner>
      <p>{{ 'PAGINA_RECUPERAR_SENHA.MENSAGEM_NOTIFICACAO_REDEFINIR_SENHA' | translate }}</p>
    </div>
  } @else {
    <div class="rs-content">
      <p class="rs-mensagem">
        {{ 'PAGINA_RECUPERAR_SENHA.ETAPA_2.MENSAGEM' | translate }}
      </p>

      <form [formGroup]="form" class="rs-form" (ngSubmit)="onSubmit()">
        <div class="rs-field">
          <lib-form-field
            [label]="'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.CODIGO_VERIFICACAO' | translate"
            controlName="token"
            [required]="true"
            [helpText]="textoAjudaCodigo"
          >
            <input
              pInputText
              id="token"
              formControlName="token"
              autocomplete="one-time-code"
              maxlength="6"
              inputmode="numeric"
              placeholder="000000"
              class="w-full rs-token-input"
            />
          </lib-form-field>
        </div>

        <div class="rs-field">
          <lib-form-field
            [label]="'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.SENHA' | translate"
            controlName="senha"
            [required]="true"
          >
            <p-password
              formControlName="senha"
              autocomplete="new-password"
              [toggleMask]="true"
              [feedback]="true"
              [placeholder]="'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.NOVA_SENHA' | translate"
              styleClass="w-full"
            >
              <ng-template pTemplate="footer">
                <div class="rs-password-requirements">
                  <p class="rs-requirements-title">
                    {{ 'GLOBAL.SENHA_CONTER' | translate }}
                  </p>
                  <ul class="rs-requirements-list">
                    <li
                      class="rs-requirement-item"
                      [class.rs-requirement-valid]="hasUpperCase()"
                    >
                      <i class="pi" [class.pi-check]="hasUpperCase()" [class.pi-times]="!hasUpperCase()"></i>
                      {{ 'GLOBAL.UMA_LETRA_MAIUSCULA' | translate }}
                    </li>
                    <li
                      class="rs-requirement-item"
                      [class.rs-requirement-valid]="hasLowerCase()"
                    >
                      <i class="pi" [class.pi-check]="hasLowerCase()" [class.pi-times]="!hasLowerCase()"></i>
                      {{ 'GLOBAL.UMA_LETRA_MINUSCULA' | translate }}
                    </li>
                    <li
                      class="rs-requirement-item"
                      [class.rs-requirement-valid]="hasNumber()"
                    >
                      <i class="pi" [class.pi-check]="hasNumber()" [class.pi-times]="!hasNumber()"></i>
                      {{ 'GLOBAL.UM_NUMERO' | translate }}
                    </li>
                    <li
                      class="rs-requirement-item"
                      [class.rs-requirement-valid]="hasSpecialChar()"
                    >
                      <i class="pi" [class.pi-check]="hasSpecialChar()" [class.pi-times]="!hasSpecialChar()"></i>
                      {{ 'GLOBAL.UM_CARACTERE_ESPECIAL' | translate }}
                    </li>
                    <li
                      class="rs-requirement-item"
                      [class.rs-requirement-valid]="hasMinLength()"
                    >
                      <i class="pi" [class.pi-check]="hasMinLength()" [class.pi-times]="!hasMinLength()"></i>
                      {{ 'GLOBAL.MINIMO_CARACTERES' | translate }}
                    </li>
                  </ul>
                </div>
              </ng-template>
            </p-password>
          </lib-form-field>
        </div>

        <div class="rs-field">
          <lib-form-field
            [label]="'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.CONFIRMAR_SENHA' | translate"
            controlName="confirmarSenha"
            [required]="true"
          >
            <input
              pInputText
              id="confirmPassword"
              formControlName="confirmarSenha"
              autocomplete="new-password"
              type="password"
              [placeholder]="'PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.CONFIRMAR_NOVA_SENHA' | translate"
              class="w-full"
            />
          </lib-form-field>

          @if (form.get('confirmarSenha')?.value) {
            <div class="rs-password-match">
              <div
                class="rs-match-status"
                [class.rs-match-valid]="senhasIguais"
                [class.rs-match-invalid]="!senhasIguais"
              >
                <i class="pi" [class.pi-check]="senhasIguais" [class.pi-times]="!senhasIguais"></i>
                <span>
                  {{
                    senhasIguais
                      ? ('PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.SENHAS_CONICIDEM' | translate)
                      : ('PAGINA_RECUPERAR_SENHA.CAMPO_TEXTO.SENHAS_NAO_CONICIDEM' | translate)
                  }}
                </span>
              </div>
            </div>
          }
        </div>

        <div class="rs-actions">
          <p-button
            [label]="'GLOBAL.CANCELAR' | translate"
            styleClass="p-button-outlined p-button-secondary"
            (onClick)="onCancelar()"
            type="button"
          />
          <p-button
            [label]="'PAGINA_RECUPERAR_SENHA.ETAPA_2.ALTERAR_SENHA' | translate"
            (onClick)="onSubmit()"
            [disabled]="form.invalid"
            [loading]="$loadingSalvar()"
            icon="pi pi-check"
            iconPos="right"
            type="button"
          />
        </div>

        <button type="button" class="rs-reenviar" (click)="reenviarCodigo()" [disabled]="$loadingEnvio()">
          {{ 'PAGINA_RECUPERAR_SENHA.REENVIAR_CODIGO' | translate }}
        </button>
      </form>
    </div>
  }
</p-dialog>
